import { t } from "@impero-com/common/utils/i18n";
import { emitNotification } from "@impero-com/ui";

import { usePostControlsBulk } from "api/generated/controls/controls";

export function useSubmitBulkImportMutation() {
    return usePostControlsBulk({
        mutation: {
            onSuccess: () => {
                emitNotification(
                    "success",
                    t("ControlsBulkImport_SubmitSuccess")
                );
            },
            onError: () => {
                emitNotification("error", t("ControlsBulkImport_SubmitError"));
            },
        },
    });
}
